import {
  Avatar,
  Box,
  Button,
  HStack,
  Image,
  Link,
  Tag,
  TagLabel,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { COLORS } from "../../../Helper/Colors";
import logo from "../../../Assets/logo.png";
import logo1 from "../../../Assets/logo1.png";
import { BellSimple } from "phosphor-react";
import avatar from "../../../Assets/profile_placeholder.jpg";

export const SetUpLayout = ({
  children,
  showAvatar,
  headerHeight = "16",
  onClick,
  headerBgColor = COLORS.brandDark,
  bodyBgColor = COLORS.bgGray,
  footerBgColor = COLORS.light,
  showAccountOptions = false,
  bodyPostion = "relative",
  isParticipant = false,
}) => {
  const bodyHeight = 100 - 8 - headerHeight;
  let date = new Date();
  let YEAR = date.getFullYear();
  return (
    <Box
      display={"flex"}
      minHeight="100vh"
      flexDirection={"column"}
      flex={1}
      justifyContent="space-between"
      zIndex={100}
    >
      <HStack
        display={"flex"}
        height={`${headerHeight}vh`}
        alignItems="center"
        id="topbar"
        justifyContent={
          !!showAvatar || !!showAccountOptions || !!isParticipant
            ? "space-between"
            : "center"
        }
        backgroundColor={headerBgColor}
        paddingX={12}
      >
        <Box display={"flex"} alignItems={"center"}>
          <Box>
            <Image src={logo} alt="App Logo" />
          </Box>
          <Box marginLeft={"20px"}>
            <Image src={logo1} alt="App Logo" />
          </Box>
        </Box>
        <HStack spacing={4} alignItems={"center"}>
          {(!!showAvatar || !!showAccountOptions) && (
            <>
              <Tag
                size={"sm"}
                variant="subtle"
                bgColor={"brand.500"}
                paddingY={1.5}
                borderRadius={"100px"}
              >
                <BellSimple
                  size={15}
                  color={COLORS.light}
                  weight="fill"
                  className="animate_notification_bell"
                />
                <TagLabel
                  marginLeft={"5px"}
                  color={"brand.100"}
                  fontWeight={"bold"}
                >
                  <Text>{Math.floor(Math.random() * 50)}</Text>
                </TagLabel>
              </Tag>
              <Avatar size={"md"} name={"John doe"} src={avatar} />
            </>
          )}
          {showAvatar && (
            <Button
              colorScheme={"twitter"}
              className="custom-btn"
              paddingY={6}
              _active={{}}
              onClick={onClick}
            >
              Return to sales site
            </Button>
          )}
          {showAccountOptions && (
            <Button
              colorScheme={"twitter"}
              className="custom-btn"
              paddingY={6}
              _active={{}}
              onClick={onClick}
            >
              Return to sales rep site
            </Button>
          )}
        </HStack>
        {isParticipant && (
          <HStack spacing={4} alignItems={"center"}>
            <Button
              colorScheme={"twitter"}
              className="custom-btn"
              paddingY={6}
              _active={{}}
              onClick={onClick}
            >
              Go to Participant
            </Button>
          </HStack>
        )}
      </HStack>
      <Box
        position={bodyPostion}
        backgroundColor={bodyBgColor}
        zIndex={100}
        overflow="auto"
        className="design-scrollbar"
        width="100%"
        height={`${bodyHeight}vh`}
      >
        {children}
      </Box>
      <Box
        display="flex"
        backgroundColor={footerBgColor}
        flexDirection={"row"}
        height={"8vh"}
        alignItems="center"
      >
        <Box
          display={"flex"}
          flex={1}
          flexDirection="row"
          justifyContent="center"
          alignItems={"center"}
        >
          <Text color={COLORS.mediumGray} marginInline={1}>
            © {YEAR}
          </Text>
          <Text>
            <Link
              color="brand.500"
              href="https://staging.just-one-moment.com"
              isExternal
            >
              justonemoment.com
            </Link>{" "}
            All Rights Reserved.
          </Text>
          <Text color={COLORS.mediumGray} marginInline={1}>
            All Rights Reserved.
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
